import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import consola from 'consola';
import userLogin from '@/graphql/user/userLogin.gql';
import autologinMutation from '@/graphql/user/authentication/autologin.gql';
import logoutUserMutation from '@/graphql/user/authentication/logoutUser.gql';
import userQuery from '~/graphql/user/me.gql';
import profileQuery from '~/graphql/user/profile.gql';
import ordersQuery from '~/graphql/user/orders.gql';
import orderQuery from '~/graphql/user/order.gql';
import addressesQuery from '~/graphql/user/address/addresses.gql';
import createUserAddressQuery from '~/graphql/user/address/createUserAddress.gql';
import updateUserAddressMutation from '~/graphql/user/address/updateUserAddress.gql';
import updateUserInformationMutation from '~/graphql/user/updateUserInformation.gql';
import updateUserPasswordMutation from '~/graphql/user/updateUserPassword.gql';
import discountsQuery from '~/graphql/user/discounts.gql';
import updateUserOptinMutation from '~/graphql/user/updateUserOptin.gql';
import deleteUserAddressQuery from '~/graphql/user/address/deleteUserAddress.gql';
import subscribeToNewsletterMutation from '~/graphql/user/newsletter.gql';
import updateUserTokenMutation from '~/graphql/user/authentication/updateUserToken.gql';
import refreshTokenMutation from '~/graphql/user/authentication/refreshToken.gql';
import { isValidToken } from '~/helpers/connection-helper';
import { logError } from '@/helpers/log-helper';

function loginUser(_x, _x2, _x3) {
  return _loginUser.apply(this, arguments);
}

function _loginUser() {
  _loginUser = _asyncToGenerator(function* (apolloClient, email, password) {
    var response = yield apolloClient.mutate({
      errorPolicy: 'all',
      mutation: userLogin,
      variables: {
        email,
        password
      }
    });
    return response;
  });
  return _loginUser.apply(this, arguments);
}

function autologin(_x4, _x5) {
  return _autologin.apply(this, arguments);
}

function _autologin() {
  _autologin = _asyncToGenerator(function* (apolloClient, token) {
    var response = yield apolloClient.mutate({
      mutation: autologinMutation,
      context: {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      }
    });
    return response;
  });
  return _autologin.apply(this, arguments);
}

function logoutUser(_x6) {
  return _logoutUser.apply(this, arguments);
}

function _logoutUser() {
  _logoutUser = _asyncToGenerator(function* (context) {
    try {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: logoutUserMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return response.data;
    } catch (e) {
      logError({
        msg: "logoutUser ".concat(e),
        context: this
      });
    }

    return null;
  });
  return _logoutUser.apply(this, arguments);
}

function fetchUser(_x7) {
  return _fetchUser.apply(this, arguments);
}

function _fetchUser() {
  _fetchUser = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      var {
        data
      } = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: userQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return data && data.user;
    }

    return null;
  });
  return _fetchUser.apply(this, arguments);
}

function fetchUserProfile(_x8) {
  return _fetchUserProfile.apply(this, arguments);
}

function _fetchUserProfile() {
  _fetchUserProfile = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      var {
        data
      } = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: profileQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return data && data.user;
    }

    return null;
  });
  return _fetchUserProfile.apply(this, arguments);
}

function fetchUserOrders(_x9, _x10, _x11) {
  return _fetchUserOrders.apply(this, arguments);
}

function _fetchUserOrders() {
  _fetchUserOrders = _asyncToGenerator(function* (context, limit, manageOrdersErrors) {
    if (isValidToken()) {
      var {
        data,
        errors
      } = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'no-cache',
        errorPolicy: manageOrdersErrors ? 'all' : 'none',
        query: ordersQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          limit,
          mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
        }
      });

      if (manageOrdersErrors && errors) {
        consola.error(errors);
      }

      return data && data.orders;
    }

    return null;
  });
  return _fetchUserOrders.apply(this, arguments);
}

function fetchUserOrder(_x12, _x13) {
  return _fetchUserOrder.apply(this, arguments);
}

function _fetchUserOrder() {
  _fetchUserOrder = _asyncToGenerator(function* (context, reference) {
    if (isValidToken()) {
      var locale = context.state.i18n.currentLocale.iso;
      var response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'no-cache',
        query: orderQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          reference,
          locale,
          mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchUserOrder.apply(this, arguments);
}

function fetchUserAddresses(_x14) {
  return _fetchUserAddresses.apply(this, arguments);
}

function _fetchUserAddresses() {
  _fetchUserAddresses = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: addressesQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchUserAddresses.apply(this, arguments);
}

function deleteUserAddress(_x15, _x16, _x17, _x18) {
  return _deleteUserAddress.apply(this, arguments);
}

function _deleteUserAddress() {
  _deleteUserAddress = _asyncToGenerator(function* (context, addressId, addressType, addressAlias) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: deleteUserAddressQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          addressId,
          addressType,
          addressAlias
        }
      });
      return response.data;
    }

    return null;
  });
  return _deleteUserAddress.apply(this, arguments);
}

function createUserAddress(_x19, _x20) {
  return _createUserAddress.apply(this, arguments);
}

function _createUserAddress() {
  _createUserAddress = _asyncToGenerator(function* (context, address) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: createUserAddressQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          address
        }
      });
      return response.data;
    }

    return null;
  });
  return _createUserAddress.apply(this, arguments);
}

function updateUserAddress(_x21, _x22, _x23) {
  return _updateUserAddress.apply(this, arguments);
}

function _updateUserAddress() {
  _updateUserAddress = _asyncToGenerator(function* (context, addressId, address) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserAddressMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          addressId,
          address
        }
      });
      return response.data;
    }

    return null;
  });
  return _updateUserAddress.apply(this, arguments);
}

function updateUserInformation(_x24, _x25) {
  return _updateUserInformation.apply(this, arguments);
}

function _updateUserInformation() {
  _updateUserInformation = _asyncToGenerator(function* (context, user) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserInformationMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          user
        }
      });
      return response.data;
    }

    return null;
  });
  return _updateUserInformation.apply(this, arguments);
}

function updateUserPassword(_x26, _x27, _x28) {
  return _updateUserPassword.apply(this, arguments);
}

function _updateUserPassword() {
  _updateUserPassword = _asyncToGenerator(function* (context, oldPassword, newPassword) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserPasswordMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          oldPassword,
          newPassword
        }
      });
      return response;
    }

    return null;
  });
  return _updateUserPassword.apply(this, arguments);
}

function fetchDiscounts(_x29) {
  return _fetchDiscounts.apply(this, arguments);
}

function _fetchDiscounts() {
  _fetchDiscounts = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      var locale = context.state.i18n.currentLocale.iso;
      var response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: discountsQuery,
        variables: {
          locale
        },
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchDiscounts.apply(this, arguments);
}

function updateUserOptin(_x30, _x31, _x32) {
  return _updateUserOptin.apply(this, arguments);
}

function _updateUserOptin() {
  _updateUserOptin = _asyncToGenerator(function* (context, input, addressId) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserOptinMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          input,
          addressId
        }
      });
      return response.data;
    }

    return null;
  });
  return _updateUserOptin.apply(this, arguments);
}

function subscribeToNewsletter(_x33, _x34, _x35) {
  return _subscribeToNewsletter.apply(this, arguments);
}

function _subscribeToNewsletter() {
  _subscribeToNewsletter = _asyncToGenerator(function* (context, email, optIn) {
    var {
      iso: locale
    } = context.state.i18n.currentLocale;
    var response = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: subscribeToNewsletterMutation,
      variables: {
        email,
        optIn,
        locale
      }
    });
    return response.data;
  });
  return _subscribeToNewsletter.apply(this, arguments);
}

function updateUserToken(_x36) {
  return _updateUserToken.apply(this, arguments);
}

function _updateUserToken() {
  _updateUserToken = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserTokenMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return response.data;
    }

    return null;
  });
  return _updateUserToken.apply(this, arguments);
}

function refreshToken(_x37) {
  return _refreshToken.apply(this, arguments);
}

function _refreshToken() {
  _refreshToken = _asyncToGenerator(function* (context) {
    var response = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: refreshTokenMutation,
      context: {}
    });
    return response.data;
  });
  return _refreshToken.apply(this, arguments);
}

export { createUserAddress, deleteUserAddress, fetchDiscounts, fetchUser, fetchUserAddresses, fetchUserOrder, fetchUserOrders, fetchUserProfile, subscribeToNewsletter, loginUser, autologin, logoutUser, updateUserAddress, updateUserInformation, updateUserOptin, updateUserPassword, updateUserToken, refreshToken };